import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, CheckCircle, XCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DriveCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("processing"); // processing, success, error
  const [error, setError] = useState("");

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const errorParam = searchParams.get("error");

      if (errorParam) {
        setStatus("error");
        setError(errorParam);
        setTimeout(() => navigate("/ayarlar?drive_error=" + errorParam), 2000);
        return;
      }

      if (!code || !state) {
        setStatus("error");
        setError("Eksik parametreler");
        setTimeout(() => navigate("/ayarlar?drive_error=missing_params"), 2000);
        return;
      }

      try {
        // Send code to backend to exchange for tokens
        await axios.get(`${API}/drive/callback/exchange`, {
          params: { code, state },
          withCredentials: true
        });
        
        setStatus("success");
        setTimeout(() => navigate("/ayarlar?drive_connected=true"), 1500);
      } catch (err) {
        setStatus("error");
        setError(err.response?.data?.detail || "Bağlantı hatası");
        setTimeout(() => navigate("/ayarlar?drive_error=" + encodeURIComponent(err.response?.data?.detail || "error")), 2000);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
        {status === "processing" && (
          <>
            <Loader2 className="w-12 h-12 text-[#1A4D2E] animate-spin mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Google Drive Bağlanıyor...</h2>
            <p className="text-gray-500">Lütfen bekleyin</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Bağlantı Başarılı!</h2>
            <p className="text-gray-500">Yönlendiriliyorsunuz...</p>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Bağlantı Hatası</h2>
            <p className="text-red-500">{error}</p>
            <p className="text-gray-500 mt-2">Yönlendiriliyorsunuz...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default DriveCallback;
